export const nazioni = [
  {
    codice: 'AF',
    nome: 'Afghanistan',
  },
  {
    codice: 'ZA',
    nome: 'Sud Africa',
  },
  {
    codice: 'AL',
    nome: 'Albania',
  },
  {
    codice: 'DZ',
    nome: 'Algeria',
  },
  {
    codice: 'AD',
    nome: 'Andorra',
  },
  {
    codice: 'AO',
    nome: 'Angola',
  },
  {
    codice: 'AI',
    nome: 'Anguilla',
  },
  {
    codice: 'AQ',
    nome: 'Antartide',
  },
  {
    codice: 'AG',
    nome: 'Antigua e Barbuda',
  },
  {
    codice: 'SA',
    nome: 'Arabia Saudita',
  },
  {
    codice: 'AR',
    nome: 'Argentina',
  },
  {
    codice: 'AM',
    nome: 'Armenia',
  },
  {
    codice: 'AW',
    nome: 'Aruba',
  },
  {
    codice: 'AU',
    nome: 'Australia',
  },
  {
    codice: 'AT',
    nome: 'Austria',
  },
  {
    codice: 'AZ',
    nome: 'Azerbaigian',
  },
  {
    codice: 'BS',
    nome: 'Bahamas',
  },
  {
    codice: 'BH',
    nome: 'Bahrein',
  },
  {
    codice: 'BD',
    nome: 'Bangladesh',
  },
  {
    codice: 'BB',
    nome: 'Barbados',
  },
  {
    codice: 'BE',
    nome: 'Belgio',
  },
  {
    codice: 'BZ',
    nome: 'Belize',
  },
  {
    codice: 'BJ',
    nome: 'Benin',
  },
  {
    codice: 'BM',
    nome: 'Bermuda',
  },
  {
    codice: 'BT',
    nome: 'Bhutan',
  },
  {
    codice: 'BY',
    nome: 'Bielorussia',
  },
  {
    codice: 'BO',
    nome: 'Bolivia',
  },
  {
    codice: 'BA',
    nome: 'Bosnia ed Erzegovina',
  },
  {
    codice: 'BW',
    nome: 'Botswana',
  },
  {
    codice: 'BR',
    nome: 'Brasile',
  },
  {
    codice: 'BN',
    nome: 'Brunei',
  },
  {
    codice: 'BG',
    nome: 'Bulgaria',
  },
  {
    codice: 'BF',
    nome: 'Burkina Faso',
  },
  {
    codice: 'BI',
    nome: 'Burundi',
  },
  {
    codice: 'KH',
    nome: 'Cambogia',
  },
  {
    codice: 'CM',
    nome: 'Camerun',
  },
  {
    codice: 'CA',
    nome: 'Canada',
  },
  {
    codice: 'CV',
    nome: 'Capo Verde',
  },
  {
    codice: 'BQ',
    nome: 'Caraibi Olandesi',
  },
  {
    codice: 'EA',
    nome: 'Ceuta e Melilla',
  },
  {
    codice: 'TD',
    nome: 'Ciad',
  },
  {
    codice: 'CL',
    nome: 'Cile',
  },
  {
    codice: 'CN',
    nome: 'Cina',
  },
  {
    codice: 'CY',
    nome: 'Cipro',
  },
  {
    codice: 'VA',
    nome: 'Città del Vaticano',
  },
  {
    codice: 'CO',
    nome: 'Colombia',
  },
  {
    codice: 'KM',
    nome: 'Comore',
  },
  {
    codice: 'CG',
    nome: 'Congo',
  },
  {
    codice: 'CD',
    nome: 'Congo, Repubblica Democratica del',
  },
  {
    codice: 'KP',
    nome: 'Corea del Nord',
  },
  {
    codice: 'KR',
    nome: 'Corea del Sud',
  },
  {
    codice: 'CR',
    nome: 'Costa Rica',
  },
  {
    codice: 'HR',
    nome: 'Croazia',
  },
  {
    codice: 'CU',
    nome: 'Cuba',
  },
  {
    codice: 'CW',
    nome: 'Curaçao',
  },
  {
    codice: 'CI',
    nome: "Costa d'Avorio",
  },
  {
    codice: 'DK',
    nome: 'Danimarca',
  },
  {
    codice: 'DG',
    nome: 'Diego Garcia',
  },
  {
    codice: 'DM',
    nome: 'Dominica',
  },
  {
    codice: 'EC',
    nome: 'Ecuador',
  },
  {
    codice: 'EG',
    nome: 'Egitto',
  },
  {
    codice: 'SV',
    nome: 'El Salvador',
  },
  {
    codice: 'AE',
    nome: 'Emirati Arabi Uniti',
  },
  {
    codice: 'ER',
    nome: 'Eritrea',
  },
  {
    codice: 'EE',
    nome: 'Estonia',
  },
  {
    codice: 'ET',
    nome: 'Etiopia',
  },
  {
    codice: 'RU',
    nome: 'Federazione Russa',
  },
  {
    codice: 'FJ',
    nome: 'Figi',
  },
  {
    codice: 'PH',
    nome: 'Filippine',
  },
  {
    codice: 'FI',
    nome: 'Finlandia',
  },
  {
    codice: 'FR',
    nome: 'Francia',
  },
  {
    codice: 'GA',
    nome: 'Gabon',
  },
  {
    codice: 'GM',
    nome: 'Gambia',
  },
  {
    codice: 'GE',
    nome: 'Georgia',
  },
  {
    codice: 'GS',
    nome: 'Georgia del Sud e Isole Sandwich Meridionali',
  },
  {
    codice: 'DE',
    nome: 'Germania',
  },
  {
    codice: 'GH',
    nome: 'Ghana',
  },
  {
    codice: 'JM',
    nome: 'Giamaica',
  },
  {
    codice: 'JP',
    nome: 'Giappone',
  },
  {
    codice: 'GI',
    nome: 'Gibilterra',
  },
  {
    codice: 'DJ',
    nome: 'Gibuti',
  },
  {
    codice: 'JO',
    nome: 'Giordania',
  },
  {
    codice: 'GR',
    nome: 'Grecia',
  },
  {
    codice: 'GD',
    nome: 'Grenada',
  },
  {
    codice: 'GL',
    nome: 'Groenlandia',
  },
  {
    codice: 'GP',
    nome: 'Guadalupa',
  },
  {
    codice: 'GU',
    nome: 'Guam',
  },
  {
    codice: 'GT',
    nome: 'Guatemala',
  },
  {
    codice: 'GG',
    nome: 'Guernsey',
  },
  {
    codice: 'GN',
    nome: 'Guinea',
  },
  {
    codice: 'GW',
    nome: 'Guinea-Bissau',
  },
  {
    codice: 'GQ',
    nome: 'Guinea Equatoriale',
  },
  {
    codice: 'GY',
    nome: 'Guyana',
  },
  {
    codice: 'GF',
    nome: 'Guyana Francese',
  },
  {
    codice: 'HT',
    nome: 'Haiti',
  },
  {
    codice: 'HN',
    nome: 'Honduras',
  },
  {
    codice: 'IN',
    nome: 'India',
  },
  {
    codice: 'ID',
    nome: 'Indonesia',
  },
  {
    codice: 'IR',
    nome: 'Iran',
  },
  {
    codice: 'IQ',
    nome: 'Iraq',
  },
  {
    codice: 'IE',
    nome: 'Irlanda',
  },
  {
    codice: 'IS',
    nome: 'Islanda',
  },
  {
    codice: 'AC',
    nome: 'Isola di Ascensione',
  },
  {
    codice: 'BV',
    nome: 'Isola di Bouvet',
  },
  {
    codice: 'CP',
    nome: 'Isola di Clipperton',
  },
  {
    codice: 'CX',
    nome: 'Isola di Natale',
  },
  {
    codice: 'IM',
    nome: 'Isola di Man',
  },
  {
    codice: 'NF',
    nome: 'Isola Norfolk',
  },
  {
    codice: 'AX',
    nome: 'Isole Aland',
  },
  {
    codice: 'KY',
    nome: 'Isole Cayman',
  },
  {
    codice: 'CC',
    nome: 'Isole Cocos (Keeling)',
  },
  {
    codice: 'CK',
    nome: 'Isole Cook',
  },
  {
    codice: 'FK',
    nome: 'Isole Falkland (Malvine)',
  },
  {
    codice: 'FO',
    nome: 'Isole Faroe',
  },
  {
    codice: 'HM',
    nome: 'Isole Heard e McDonald',
  },
  {
    codice: 'MP',
    nome: 'Isole Marianne Settentrionali',
  },
  {
    codice: 'MH',
    nome: 'Isole Marshall',
  },
  {
    codice: 'PN',
    nome: 'Isole Pitcairn',
  },
  {
    codice: 'SB',
    nome: 'Isole Solomon',
  },
  {
    codice: 'TC',
    nome: 'Isole Turks e Caicos',
  },
  {
    codice: 'UM',
    nome: 'Isole minori esterne degli Stati Uniti',
  },
  {
    codice: 'VG',
    nome: 'Isole Vergini Britanniche',
  },
  {
    codice: 'VI',
    nome: 'Isole Vergini Americane',
  },
  {
    codice: 'IL',
    nome: 'Israele',
  },
  {
    codice: 'IT',
    nome: 'Italia',
  },
  {
    codice: 'JE',
    nome: 'Jersey',
  },
  {
    codice: 'KZ',
    nome: 'Kazakistan',
  },
  {
    codice: 'KE',
    nome: 'Kenya',
  },
  {
    codice: 'KG',
    nome: 'Kirghizistan',
  },
  {
    codice: 'KI',
    nome: 'Kiribati',
  },
  {
    codice: 'KW',
    nome: 'Kuwait',
  },
  {
    codice: 'LA',
    nome: 'Laos',
  },
  {
    codice: 'LS',
    nome: 'Lesotho',
  },
  {
    codice: 'LV',
    nome: 'Lettonia',
  },
  {
    codice: 'LB',
    nome: 'Libano',
  },
  {
    codice: 'LR',
    nome: 'Liberia',
  },
  {
    codice: 'LY',
    nome: 'Libia',
  },
  {
    codice: 'LI',
    nome: 'Liechtenstein',
  },
  {
    codice: 'LT',
    nome: 'Lituania',
  },
  {
    codice: 'LU',
    nome: 'Lussemburgo',
  },
  {
    codice: 'MO',
    nome: 'Macao',
  },
  {
    codice: 'MK',
    nome: 'Macedonia del Nord',
  },
  {
    codice: 'MG',
    nome: 'Madagascar',
  },
  {
    codice: 'MW',
    nome: 'Malawi',
  },
  {
    codice: 'MV',
    nome: 'Maldive',
  },
  {
    codice: 'MY',
    nome: 'Malesia',
  },
  {
    codice: 'ML',
    nome: 'Mali',
  },
  {
    codice: 'MT',
    nome: 'Malta',
  },
  {
    codice: 'MA',
    nome: 'Marocco',
  },
  {
    codice: 'MQ',
    nome: 'Martinica',
  },
  {
    codice: 'MR',
    nome: 'Mauritania',
  },
  {
    codice: 'MU',
    nome: 'Mauritius',
  },
  {
    codice: 'YT',
    nome: 'Mayotte',
  },
  {
    codice: 'MX',
    nome: 'Messico',
  },
  {
    codice: 'FM',
    nome: 'Micronesia',
  },
  {
    codice: 'MZ',
    nome: 'Mozambico',
  },
  {
    codice: 'MD',
    nome: 'Moldavia',
  },
  {
    codice: 'MC',
    nome: 'Monaco',
  },
  {
    codice: 'MN',
    nome: 'Mongolia',
  },
  {
    codice: 'ME',
    nome: 'Montenegro',
  },
  {
    codice: 'MS',
    nome: 'Montserrat',
  },
  {
    codice: 'MM',
    nome: 'Myanmar (Birmania)',
  },
  {
    codice: 'NA',
    nome: 'Namibia',
  },
  {
    codice: 'NR',
    nome: 'Nauru',
  },
  {
    codice: 'NP',
    nome: 'Nepal',
  },
  {
    codice: 'NI',
    nome: 'Nicaragua',
  },
  {
    codice: 'NE',
    nome: 'Niger',
  },
  {
    codice: 'NG',
    nome: 'Nigeria',
  },
  {
    codice: 'NU',
    nome: 'Niue',
  },
  {
    codice: 'NO',
    nome: 'Norvegia',
  },
  {
    codice: 'NC',
    nome: 'Nuova Caledonia',
  },
  {
    codice: 'NZ',
    nome: 'Nuova Zelanda',
  },
  {
    codice: 'OM',
    nome: 'Oman',
  },
  {
    codice: 'NL',
    nome: 'Paesi Bassi',
  },
  {
    codice: 'PK',
    nome: 'Pakistan',
  },
  {
    codice: 'PW',
    nome: 'Palau',
  },
  {
    codice: 'PA',
    nome: 'Panama',
  },
  {
    codice: 'PG',
    nome: 'Papua Nuova Guinea',
  },
  {
    codice: 'PY',
    nome: 'Paraguay',
  },
  {
    codice: 'PE',
    nome: 'Perù',
  },
  {
    codice: 'PF',
    nome: 'Polinesia Francese',
  },
  {
    codice: 'PL',
    nome: 'Polonia',
  },
  {
    codice: 'PT',
    nome: 'Portogallo',
  },
  {
    codice: 'PR',
    nome: 'Porto Rico',
  },
  {
    codice: 'QA',
    nome: 'Qatar',
  },
  {
    codice: 'GB',
    nome: 'Regno Unito',
  },
  {
    codice: 'CZ',
    nome: 'Repubblica Ceca',
  },
  {
    codice: 'CF',
    nome: 'Repubblica Centrafricana',
  },
  {
    codice: 'DO',
    nome: 'Repubblica Dominicana',
  },
  {
    codice: 'RE',
    nome: 'Réunion',
  },
  {
    codice: 'RO',
    nome: 'Romania',
  },
  {
    codice: 'RW',
    nome: 'Ruanda',
  },
  {
    codice: 'EH',
    nome: 'Sahara Occidentale',
  },
  {
    codice: 'KN',
    nome: 'Saint Kitts e Nevis',
  },
  {
    codice: 'LC',
    nome: 'Saint Lucia',
  },
  {
    codice: 'MF',
    nome: 'Saint Martin',
  },
  {
    codice: 'PM',
    nome: 'Saint Pierre e Miquelon',
  },
  {
    codice: 'VC',
    nome: 'Saint Vincent e Grenadine',
  },
  {
    codice: 'WS',
    nome: 'Samoa',
  },
  {
    codice: 'SM',
    nome: 'San Marino',
  },
  {
    codice: 'ST',
    nome: 'São Tomé e Príncipe',
  },
  {
    codice: 'SA',
    nome: 'Arabia Saudita',
  },
  {
    codice: 'SN',
    nome: 'Senegal',
  },
  {
    codice: 'RS',
    nome: 'Serbia',
  },
  {
    codice: 'SC',
    nome: 'Seychelles',
  },
  {
    codice: 'SL',
    nome: 'Sierra Leone',
  },
  {
    codice: 'SG',
    nome: 'Singapore',
  },
  {
    codice: 'SX',
    nome: 'Sint Maarten',
  },
  {
    codice: 'SY',
    nome: 'Siria',
  },
  {
    codice: 'SK',
    nome: 'Slovacchia',
  },
  {
    codice: 'SI',
    nome: 'Slovenia',
  },
  {
    codice: 'SO',
    nome: 'Somalia',
  },
  {
    codice: 'ES',
    nome: 'Spagna',
  },
  {
    codice: 'LK',
    nome: 'Sri Lanka',
  },
  {
    codice: 'US',
    nome: 'Stati Uniti',
  },
  {
    codice: 'ZA',
    nome: 'Sudafrica',
  },
  {
    codice: 'SD',
    nome: 'Sudan',
  },
  {
    codice: 'SS',
    nome: 'Sudan del Sud',
  },
  {
    codice: 'SE',
    nome: 'Svezia',
  },
  {
    codice: 'CH',
    nome: 'Svizzera',
  },
  {
    codice: 'SR',
    nome: 'Suriname',
  },
  {
    codice: 'SJ',
    nome: 'Svalbard e Jan Mayen',
  },
  {
    codice: 'SZ',
    nome: 'Swaziland',
  },
  {
    codice: 'TJ',
    nome: 'Tagikistan',
  },
  {
    codice: 'TW',
    nome: 'Taiwan',
  },
  {
    codice: 'TZ',
    nome: 'Tanzania',
  },
  {
    codice: 'TF',
    nome: 'Territori Francesi del Sud',
  },
  {
    codice: 'IO',
    nome: "Territorio Britannico dell'Oceano Indiano",
  },
  {
    codice: 'TH',
    nome: 'Thailandia',
  },
  {
    codice: 'TL',
    nome: 'Timor Est',
  },
  {
    codice: 'TG',
    nome: 'Togo',
  },
  {
    codice: 'TK',
    nome: 'Tokelau',
  },
  {
    codice: 'TO',
    nome: 'Tonga',
  },
  {
    codice: 'TT',
    nome: 'Trinidad e Tobago',
  },
  {
    codice: 'TN',
    nome: 'Tunisia',
  },
  {
    codice: 'TM',
    nome: 'Turkmenistan',
  },
  {
    codice: 'TR',
    nome: 'Turchia',
  },
  {
    codice: 'TV',
    nome: 'Tuvalu',
  },
  {
    codice: 'UA',
    nome: 'Ucraina',
  },
  {
    codice: 'UG',
    nome: 'Uganda',
  },
  {
    codice: 'HU',
    nome: 'Ungheria',
  },
  {
    codice: 'UY',
    nome: 'Uruguay',
  },
  {
    codice: 'UZ',
    nome: 'Uzbekistan',
  },
  {
    codice: 'VU',
    nome: 'Vanuatu',
  },
  {
    codice: 'VA',
    nome: 'Città del Vaticano',
  },
  {
    codice: 'VE',
    nome: 'Venezuela',
  },
  {
    codice: 'VN',
    nome: 'Vietnam',
  },
  {
    codice: 'WF',
    nome: 'Wallis e Futuna',
  },
  {
    codice: 'YE',
    nome: 'Yemen',
  },
  {
    codice: 'ZM',
    nome: 'Zambia',
  },
  {
    codice: 'ZW',
    nome: 'Zimbabwe',
  },
]
